import React from "react";
import "./Card.css";

const Card = (props) => {
  const cardProps = {
    style: { height: '100%', ...(props.style ? props.style : undefined)},
    className: "card"
  }

  return (
    <div {...cardProps}>
      {props.children}
    </div>
  )
};

export default Card;
